import { useEffect, useState, useRef } from "react";

import ColorThief from "colorthief";

import styles from "./index.module.css";

import Cookies from "js-cookie";
import {
  useAppDispatch,
  useAppSelector,
} from "../../../../../../hooks/reduxHooks";
import {
  addImage,
  deSelectObject,
  resetObjectToInitialState,
  updateImage,
  updateImageProp,
} from "../../../../../store/slices/viewSlice";
import { APP_CONSTANTS } from "../../../../../../constants/AppConstants";
import RangeSlider from "../../../RangeSlider";
import Checkbox from "../../../Checkbox";
import ColorPicker from "../../../ColorPicker";
import { getUniqueArray } from "../../../../../utils/utils";
import InfoBlock from "../../../../../../components/InfoBlock";
import Popup from "../../../Popup";
import Infoblock from "../../../InfoBlock";
import SaveDesign from "../../../SaveDesign";
import axios from "axios";
import { removeBackgroundAPI } from "../../../../../api/editor.api";
import { MoonLoader } from "react-spinners";
import { checkAndCreateSessionIdFromCookie } from "../../../../../../utils/utils";

const parsedColors = ["#022A44", "#F1E5CA", "#820219", "#818889"];
const availableColors = [
  "#dedede",
  "#939495",
  "#747163",
  "#f6e44a",
  "#f4a323",
  "#fff98a",
  "#20419a",
  "#0ca2bd",
  "#353f4b",
  "#ff7700",
  "#3f510d",
  "#02642e",
  "#c3f17a",
  "#6fcf91",
  "#b1ecb5",
  "#b51717",
  "#ef4848",
  "#ffc2c4",
  "#5e3a8c",
  "#55387a",
  "#34101b",
];

const EditUpload = ({ handleChangeColors }: any) => {
  const [showSaveDesign, setShowSaveDesign] = useState(false);
  const [selectedWidth, setSelectedWidth] = useState<any>(0);
  const [selectedHeight, setSelectedHeight] = useState<any>(0);
  const [showColorPicker, setShowColorPicker] = useState(false);
  const [enableColorPicker, setEnableColorPicker] = useState(false);
  const [show, setShow] = useState(false);
  const isLoggedIn = false;
  const [sessionId, setSessionId] = useState("id" + new Date().getTime());
  const [dominantColor, setDominantColor] = useState<any>(null);
  const [backgroundLoading, setBackgroundLoading] = useState(false);
  const [colorPalette, setColorPalette] = useState([]);
  const selectedObject = useAppSelector(
    (state: any) => state.canvases.selectedObject
  );
  const selectedEffect = useAppSelector(
    (state: any) => state.canvases.selectedEffect
  );
  const dispatch = useAppDispatch();

  const win: any = window;
  const selectedViewId = useAppSelector(
    (state: any) => state.canvases.selectedViewId
  );
  const canvas: any = win["design_canvas"][selectedViewId];
  const [threshold, setThreshold] = useState(10);
  const hexToRgb = (hex: any) => {
    const bigint = parseInt(hex.slice(1), 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;

    return [r, g, b];
  };
  useEffect(() => {
    if (selectedObject && selectedObject.filters && selectedObject.filters[0]) {
      setEnableColorPicker(true);
    } else {
      setEnableColorPicker(false);
    }
  }, [selectedObject]);

  const replaceColorInImage = (
    image: any,
    oldColor: any,
    newColor: any,
    tolerance = 100,
    threshold = 0
  ) => {
    const canvas = document.createElement("canvas");
    const ctx: any = canvas.getContext("2d");

    canvas.width = image.width;
    canvas.height = image.height;

    ctx.drawImage(image, 0, 0);

    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
    const data = imageData.data;

    for (let i = 0; i < data.length; i += 4) {
      const colorDiff =
        Math.abs(data[i] - oldColor[0]) +
        Math.abs(data[i + 1] - oldColor[1]) +
        Math.abs(data[i + 2] - oldColor[2]);

      if (colorDiff <= threshold + tolerance) {
        data[i] = newColor[0];
        data[i + 1] = newColor[1];
        data[i + 2] = newColor[2];
        data[i + 3] = newColor[3] !== undefined ? newColor[3] : data[i + 3];
      }
    }

    ctx.putImageData(imageData, 0, 0);

    return canvas.toDataURL();
  };

  function removeBackgroundColorAndReturnBase64(
    imageUrl: string,
    backgroundColor: string,
    format: string = "image/png"
  ): Promise<string> {
    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageUrl;
      image.crossOrigin = "anonymous";
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");

        if (!ctx) {
          reject("Canvas context not supported.");
          return;
        }

        ctx.drawImage(image, 0, 0, image.width, image.height);

        const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        const data = imageData.data;
        const [r, g, b] = [255, 255, 255];

        for (let i = 0; i < data.length; i += 4) {
          const red = data[i];
          const green = data[i + 1];
          const blue = data[i + 2];

          if (red === r && green === g && blue === b) {
            data[i + 3] = 0; // Set alpha channel to 0 (transparent) for the background color
          }
        }

        ctx.putImageData(imageData, 0, 0);

        const base64Image = canvas.toDataURL(format);
        console.log(base64Image);
        resolve(base64Image);
      };

      image.onerror = () => {
        reject("Image loading failed.");
      };
    });
  }
  const removeBackgroundColor = async (val: boolean) => {
    if (!val) {
      dispatch(
        addImage({
          img: selectedObject.originalImg,
        })
      );
    } else {
      const image = selectedObject.getSrc
        ? selectedObject.getSrc()
        : selectedObject.src;
      if (image) {
        const bgColorRGB = hexToRgb("#fffff");

        // const data = await removeBackgroundColorAndReturnBase64(
        //   image,
        //   "rgba(255, 255, 255, 1)"
        // );
        // dispatch(
        //   addImage({
        //     img: data,
        //     // width: img.width,
        //     // height: img.height,
        //   })
        // );

        const uploadedImage = new Image();
        uploadedImage.src = image;
        uploadedImage.crossOrigin = "anonymous";
        uploadedImage.onload = (img) => {
          const newImage = replaceColorInImage(
            img.target,
            bgColorRGB,
            [0, 0, 0, 0],
            threshold
          );
          dispatch(
            updateImage({
              img: newImage,
              originalImg: image,
              //  width: img.width,
              //  height: img.height,
            })
          );
        };
      }
    }
  };

  const loadColors = () => {
    const img = new Image();
    const colorThief = new ColorThief();
    img.src = selectedObject.getSrc
      ? selectedObject.getSrc()
      : selectedObject.src;
    img.crossOrigin = "anonymous";

    img.onload = () => {
      const color = colorThief.getColor(img);
      const hexColor = `#${(
        (1 << 24) +
        (color[0] << 16) +
        (color[1] << 8) +
        color[2]
      )
        .toString(16)
        .slice(1)}`;
      const palette = colorThief.getPalette(img, 6); // You can change the second parameter to get a different number of colors
      const hexPalette = palette.map(
        (color: any) =>
          `#${((1 << 24) + (color[0] << 16) + (color[1] << 8) + color[2])
            .toString(16)
            .slice(1)}`
      );

      setDominantColor(hexColor);
      setColorPalette(hexPalette);
    };
  };

  useEffect(() => {
    const uniqueId: any = checkAndCreateSessionIdFromCookie();
    setSessionId(uniqueId);
    const incrementedCount =
      parseInt(Cookies.get("User_Session_Count") as any) + 1;
    Cookies.set("User_Session_Count", incrementedCount.toString());
  }, []);
  useEffect(() => {
    const width = ((selectedObject.width * selectedObject.scaleX) / 96).toFixed(
      2
    );
    const height = (
      (selectedObject.height * selectedObject.scaleY) /
      96
    ).toFixed(2);
    setSelectedWidth(width);
    setSelectedHeight(height);

    loadColors();
  }, [selectedObject]);

  const handleUpdateProp = (prop: string, value?: any) => {
    dispatch(updateImageProp({ prop: prop, value: value }));
    canvas.renderAll();
  };
  const updateFilter = (prop: string, value?: any) => {
    dispatch(
      updateImageProp({ prop: prop, value: { type: "tint", color: value } })
    );
    canvas.renderAll();
  };
  const deSelectObjectAction = () => {
    dispatch(deSelectObject({}));
    canvas.renderAll();
  };
  const handleReset = () => {
    dispatch(resetObjectToInitialState({}));
    canvas.renderAll();
  };
  const processValue = (inputValue: any) => {
    // Define a regular expression pattern for a valid value like "2.0"
    // It should accept only numbers and decimal point
    var validPattern = /^(0|[1-9]\d*)?(\.\d+)?$/;

    // Check if the inputValue matches the valid pattern
    if (validPattern.test(inputValue)) {
      // Value is valid, proceed to the other function
      return true;
    } else {
      // Value is invalid, provide an error message to the user
      return false;
    }
  };

  const getOriginalImage = (img: any) => {
    let originalImg = img.replace("designer", "original");
    originalImg = originalImg.replace("thumb", "original");
    return originalImg;
  };

  const removeBackground = (val: any) => {
    const canvas: any = win["design_canvas"][selectedViewId];
    const selectedOb = canvas.getActiveObject();
    const selectedImage = selectedOb.getSrc();
    // debugger;
    if (val) {
      // debugger;
      if (selectedOb.remove_background_data) {
        dispatch(
          updateImage({
            img: getOriginalImage(selectedOb.remove_background_data.path),
            originalImg: selectedOb.originalImg,
            extraProps: {
              is_remove_background: true,
            },
            //  width: img.width,
            //  height: img.height,
          })
        );
      } else {
        setBackgroundLoading(true);
        const imgURL = selectedImage.startsWith("data:image")
          ? selectedOb.originalImg
          : selectedImage;
        removeBackgroundAPI(imgURL).then(
          (data) => {
            const img = new Image();
            img.src = getOriginalImage(data.path);
            img.crossOrigin = "anonymous";
            img.onload = () => {
              setBackgroundLoading(false);
              dispatch(
                updateImage({
                  img: getOriginalImage(data.path),
                  originalImg: selectedImage,
                  extraProps: {
                    remove_background_data: data,
                    is_remove_background: true,
                  },

                  //  width: img.width,
                  //  height: img.height,
                })
              );
              img.onload = null;
            };

            // console.log(data)
            // self.editorMediator.addOrUpdateImage(data.cf_rembg_url.replace('original', 'designer'), { keep_original: true, is_remove_background: true, des_bg_rem_src: data.cf_rembg_url.replace('original', 'designer'), org_bg_rem_src: data.cf_rembg_url }, function() {
            //     $('[data-remove-background-loader]').hide();
            //     $('[data-remove-background-switch]').show();
            // })
          },
          (err) => {
            setBackgroundLoading(false);
            // self.showUploadError();
            // $('[data-remove-background-loader]').hide();
            // $('[data-remove-background-switch]').show();
          }
        );
      }
    } else {
      dispatch(
        updateImage({
          img: selectedOb.originalImg,
          originalImg: selectedOb.originalImg,
          extraProps: {
            is_remove_background: false,
          },
          //  width: img.width,
          //  height: img.height,
        })
      );
    }
  };

  const updateWidth = (event: any) => {
    setSelectedWidth(event.target.value);
    if (!processValue(event.target.value)) return;
    var existingWidth = selectedObject.width;
    var existingHeight = selectedObject.height;

    let widthOfObject = parseFloat(event.target.value) * 96;
    let widthSf = widthOfObject / existingWidth;
    setSelectedWidth(parseFloat(event.target.value));
    const he = (existingHeight * widthSf) / 96;
    setSelectedHeight(he.toFixed(2));
    handleUpdateProp("scaleX", widthSf);
    handleUpdateProp("scaleY", widthSf);

    // self.editorMediator.updateImageWidthAndHeight(widthOfObject, heightOfObject, 1, 1);
  };
  const updateHeight = (event: any) => {
    setSelectedHeight(event.target.value);
    if (!processValue(event.target.value)) return;
    var existingHeight = selectedObject.height;
    var existingWidth = selectedObject.width;
    let widthOfObject = parseFloat(event.target.value) * 96;
    let heightSf = widthOfObject / existingHeight;
    setSelectedHeight(parseFloat(event.target.value));
    const we = (existingWidth * heightSf) / 96;
    setSelectedWidth(we.toFixed(2));
    handleUpdateProp("scaleX", heightSf);
    handleUpdateProp("scaleY", heightSf);
  };

  // Add debounce timer ref
  const debounceTimerRef = useRef<any>(null);
  
  // Clean up timer when component unmounts
  useEffect(() => {
    return () => {
      if (debounceTimerRef.current) {
        clearTimeout(debounceTimerRef.current);
      }
    };
  }, []);

  return (
    <>
      <div className="bg-[#F6F6F6] p-3">
        <div className="flex justify-between items-center gap-2 flex-wrap mb-2 text-center">
          <div>
            <div className={styles.inputGroup}>
              <button
                onClick={() =>
                  handleUpdateProp("objectAlignment", "horizontal")
                }
              >
                <svg
                  width="25"
                  height="8"
                  viewBox="0 0 25 8"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M11.1667 2.00003C11.1667 1.26403 11.7587 0.666695 12.5 0.666695C13.236 0.666695 13.8333 1.2587 13.8333 2.00003V6.00003C13.8333 6.73603 13.2413 7.33336 12.5 7.33336C11.764 7.33336 11.1667 6.74136 11.1667 6.00003V2.00003ZM18.8027 5.34403C17.5307 4.60136 17.5293 3.40003 18.8027 2.65603L22.1973 0.677362C23.4693 -0.0653046 24.5 0.525361 24.5 1.99603V6.00403C24.5 7.4747 23.4707 8.06669 22.1973 7.32403L18.8027 5.34403ZM6.19733 5.34403L2.80267 7.32269C1.52933 8.06669 0.5 7.4747 0.5 6.00403V1.99603C0.5 0.525361 1.53067 -0.0653052 2.80267 0.676028L6.19733 2.65603C7.47067 3.40003 7.46933 4.6027 6.19733 5.34403Z"
                    fill="#222020"
                  />
                </svg>
              </button>
              <button
                onClick={() => handleUpdateProp("objectAlignment", "vertical")}
              >
                <svg
                  width="9"
                  height="24"
                  viewBox="0 0 9 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M6.50009 10.6667C7.23609 10.6667 7.83343 11.2587 7.83343 12C7.83343 12.736 7.24143 13.3333 6.50009 13.3333H2.50009C1.76409 13.3333 1.16676 12.7413 1.16676 12C1.16676 11.264 1.75876 10.6667 2.50009 10.6667H6.50009ZM3.15609 18.3027C3.89876 17.0307 5.10009 17.0293 5.84409 18.3027L7.82276 21.6973C8.56543 22.9693 7.97476 24 6.50409 24H2.49609C1.02543 24 0.433427 22.9707 1.17609 21.6973L3.15609 18.3027ZM3.15609 5.69733L1.17743 2.30267C0.433428 1.02933 1.02543 0 2.49609 0H6.50409C7.97476 0 8.56543 1.03067 7.82409 2.30267L5.84409 5.69733C5.10009 6.97067 3.89743 6.96933 3.15609 5.69733Z"
                    fill="#222020"
                  />
                </svg>
              </button>
              <button onClick={() => handleUpdateProp("objectAlignment")}>
                <svg
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M17.3333 18C17.3333 18.736 16.7413 19.3333 16 19.3333C15.264 19.3333 14.6667 18.7413 14.6667 18V14C14.6667 13.264 15.2587 12.6667 16 12.6667C16.736 12.6667 17.3333 13.2587 17.3333 14V18ZM9.69733 14.656C10.9693 15.3987 10.9707 16.6 9.69733 17.344L6.30267 19.3227C5.03066 20.0653 4 19.4747 4 18.004V13.996C4 12.5253 5.02933 11.9333 6.30267 12.676L9.69733 14.656ZM22.3027 14.656L25.6973 12.6773C26.9707 11.9333 28 12.5253 28 13.996V18.004C28 19.4747 26.9693 20.0653 25.6973 19.324L22.3027 17.344C21.0293 16.6 21.0307 15.3973 22.3027 14.656Z"
                    fill="#222020"
                  />
                  <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M18.0001 14.6667C18.7361 14.6667 19.3334 15.2587 19.3334 16C19.3334 16.736 18.7414 17.3333 18.0001 17.3333H14.0001C13.2641 17.3333 12.6668 16.7413 12.6668 16C12.6668 15.264 13.2588 14.6667 14.0001 14.6667H18.0001ZM14.6561 22.3027C15.3988 21.0307 16.6001 21.0293 17.3441 22.3027L19.3228 25.6973C20.0654 26.9693 19.4748 28 18.0041 28H13.9961C12.5254 28 11.9334 26.9707 12.6761 25.6973L14.6561 22.3027ZM14.6561 9.69733L12.6774 6.30267C11.9334 5.02933 12.5254 4 13.9961 4H18.0041C19.4748 4 20.0654 5.03067 19.3241 6.30267L17.3441 9.69733C16.6001 10.9707 15.3974 10.9693 14.6561 9.69733Z"
                    fill="#222020"
                  />
                </svg>
              </button>
            </div>
            <div className="text-[10px]">Center</div>
          </div>
          <div>
            <div className={styles.inputGroup}>
              <button onClick={() => handleUpdateProp("bringForward")}>
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.6646 10.406L9.89798 15.2936C9.7935 15.3601 9.67226 15.3953 9.54845 15.3953C9.42465 15.3953 9.30341 15.3601 9.19893 15.2936L1.43322 10.406C1.33293 10.3422 1.25056 10.2539 1.1939 10.1494C1.13724 10.0449 1.10816 9.92773 1.10941 9.80887C1.10941 9.56221 1.23036 9.33935 1.43322 9.21173L2.57607 8.49173L8.87131 12.4527C9.07414 12.5807 9.30908 12.6487 9.54893 12.6487C9.78878 12.6487 10.0237 12.5807 10.2266 12.4527L16.5208 8.49078L17.6637 9.21173C17.8675 9.33935 17.9885 9.56221 17.9885 9.80887C17.9896 9.92771 17.9605 10.0449 17.9038 10.1494C17.8472 10.2538 17.7649 10.3422 17.6646 10.406ZM17.6646 12.6136C17.8675 12.7413 17.9885 12.9641 17.9885 13.2108C17.9897 13.3296 17.9606 13.4468 17.904 13.5513C17.8473 13.6558 17.7649 13.7441 17.6646 13.8079L9.89798 18.6946C9.79354 18.7611 9.67229 18.7965 9.54845 18.7965C9.42462 18.7965 9.30337 18.7611 9.19893 18.6946L1.43322 13.8079C1.33293 13.7441 1.25056 13.6558 1.1939 13.5513C1.13724 13.4468 1.10816 13.3296 1.10941 13.2108C1.10941 12.9641 1.23036 12.7413 1.43322 12.6136L2.57607 11.8936L8.87131 15.8546C9.07414 15.9826 9.30908 16.0506 9.54893 16.0506C9.78878 16.0506 10.0237 15.9826 10.2266 15.8546L16.5208 11.8927L17.6646 12.6136ZM18.6218 9.80887C18.6218 9.33078 18.3866 8.8984 17.9932 8.65078L17.1304 8.10792L17.9923 7.56506C18.3866 7.31745 18.6208 6.88411 18.6208 6.40697C18.6208 5.92887 18.3866 5.49649 17.9923 5.24887L10.2266 0.361255C10.024 0.232465 9.78895 0.164062 9.54893 0.164062C9.30891 0.164063 9.07386 0.232465 8.87131 0.361255L1.10465 5.24983C0.711312 5.49745 0.476074 5.92983 0.476074 6.40792C0.476074 6.88507 0.711312 7.3184 1.10465 7.56602L1.96655 8.10887L1.10465 8.65173C0.711312 8.89935 0.476074 9.33173 0.476074 9.80983C0.476074 10.287 0.711312 10.7203 1.10465 10.9679L1.96655 11.5108L1.10465 12.0536C0.711312 12.3013 0.476074 12.7336 0.476074 13.2117C0.476074 13.6889 0.711312 14.1222 1.10465 14.3698L8.87131 19.2574C9.07414 19.3855 9.30908 19.4534 9.54893 19.4534C9.78878 19.4534 10.0237 19.3855 10.2266 19.2574L17.9923 14.3698C18.3866 14.1222 18.6208 13.6889 18.6208 13.2117C18.6208 12.7336 18.3866 12.3013 17.9923 12.0536L17.1304 11.5108L17.9923 10.9679C18.3866 10.7203 18.6208 10.287 18.6208 9.80983L18.6218 9.80887Z"
                    fill="#4A4A4A"
                  />
                </svg>
              </button>
              <button onClick={() => handleUpdateProp("sendBackwards")}>
                <svg
                  width="19"
                  height="20"
                  viewBox="0 0 19 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M17.6646 10.406L9.89798 15.2936C9.7935 15.3601 9.67226 15.3953 9.54845 15.3953C9.42465 15.3953 9.30341 15.3601 9.19893 15.2936L1.43322 10.406C1.33293 10.3422 1.25056 10.2539 1.1939 10.1494C1.13724 10.0449 1.10816 9.92773 1.10941 9.80887C1.10941 9.56221 1.23036 9.33935 1.43322 9.21173L2.57607 8.49173L8.87131 12.4527C9.07414 12.5807 9.30908 12.6487 9.54893 12.6487C9.78878 12.6487 10.0237 12.5807 10.2266 12.4527L16.5208 8.49078L17.6637 9.21173C17.8675 9.33935 17.9885 9.56221 17.9885 9.80887C17.9896 9.92771 17.9605 10.0449 17.9038 10.1494C17.8472 10.2538 17.7649 10.3422 17.6646 10.406ZM1.10845 6.40602C1.10845 6.1603 1.23036 5.93745 1.43226 5.80983L9.19988 0.922208C9.30448 0.856109 9.42568 0.821025 9.54941 0.821025C9.67314 0.821025 9.79433 0.856109 9.89893 0.922208L17.6656 5.80983C17.8685 5.93745 17.9894 6.1603 17.9894 6.40697C17.9907 6.52582 17.9616 6.64303 17.9049 6.74752C17.8483 6.852 17.7659 6.94032 17.6656 7.00411L9.89893 11.8917C9.7945 11.9583 9.67324 11.9936 9.54941 11.9936C9.42558 11.9936 9.30432 11.9583 9.19988 11.8917L1.43417 7.00411C1.33388 6.94032 1.25152 6.852 1.19486 6.74752C1.1382 6.64303 1.10912 6.52582 1.11036 6.40697M18.6227 9.80887C18.6227 9.33078 18.3875 8.8984 17.9942 8.65078L17.1313 8.10792L17.9932 7.56506C18.3875 7.31745 18.6218 6.88411 18.6218 6.40697C18.6218 5.92887 18.3875 5.49649 17.9932 5.24887L10.2266 0.361255C10.024 0.232465 9.78895 0.164062 9.54893 0.164062C9.30891 0.164063 9.07386 0.232465 8.87131 0.361255L1.10465 5.24983C0.711312 5.49745 0.476074 5.92983 0.476074 6.40792C0.476074 6.88507 0.711312 7.3184 1.10465 7.56602L1.96655 8.10887L1.10465 8.65173C0.711312 8.89935 0.476074 9.33173 0.476074 9.80983C0.476074 10.287 0.711312 10.7203 1.10465 10.9679L1.96655 11.5108L1.10465 12.0536C0.711312 12.3013 0.476074 12.7336 0.476074 13.2117C0.476074 13.6889 0.711312 14.1222 1.10465 14.3698L8.87131 19.2574C9.07414 19.3855 9.30908 19.4534 9.54893 19.4534C9.78878 19.4534 10.0237 19.3855 10.2266 19.2574L17.9923 14.3698C18.3866 14.1222 18.6208 13.6889 18.6208 13.2117C18.6208 12.7336 18.3866 12.3013 17.9923 12.0536L17.1304 11.5108L17.9923 10.9679C18.3866 10.7203 18.6208 10.287 18.6208 9.80983"
                    fill="#4A4A4A"
                  />
                </svg>
              </button>
            </div>
            <div className="text-[10px]">Layering</div>
          </div>
          <div>
            <div className={styles.inputGroup}>
              <button onClick={() => handleUpdateProp("flipX")}>
                <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                  <g stroke="#4A4A4A" strokeLinejoin="round">
                    <path fill="#4A4A4A" d="M1 3v12l5-6z"></path>
                    <path fill="none" d="M17 3v12l-5-6z"></path>
                  </g>
                  <g fill="#4A4A4A">
                    <path d="M8.362 10.784h1.275v1.334H8.362z"></path>
                    <path d="M8.362 16.118h1.275v1.334H8.362z"></path>
                    <path d="M8.362 8.117h1.275v1.334H8.362z"></path>
                    <path d="M8.362 13.451h1.275v1.334H8.362z"></path>
                    <path d="M8.362 5.449h1.275v1.334H8.362z"></path>
                    <path d="M8.362.115h1.275v1.334H8.362z"></path>
                    <path d="M8.362 2.782h1.275v1.334H8.362z"></path>
                  </g>
                </svg>
              </button>
              <button onClick={() => handleUpdateProp("flipY")}>
                <svg viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                  <g stroke="#4A4A4A" strokeLinejoin="round">
                    <path fill="#4A4A4A" d="M3 1h12L9 6z"></path>
                    <path fill="none" d="M3 17h12l-6-5z"></path>
                  </g>
                  <g fill="#4A4A4A">
                    <path d="M10.784 8.362h1.334v1.275h-1.334z"></path>
                    <path d="M16.118 8.362h1.334v1.275h-1.334z"></path>
                    <path d="M8.117 8.362h1.334v1.275H8.117z"></path>
                    <path d="M13.451 8.362h1.334v1.275h-1.334z"></path>
                    <path d="M5.449 8.362h1.334v1.275H5.449z"></path>
                    <path d=".115 8.362h1.334v1.275H.115z"></path>
                    <path d="M2.782 8.362h1.334v1.275H2.782z"></path>
                  </g>
                </svg>
              </button>
            </div>
            <div className="text-[10px]">Flip</div>
          </div>
        </div>
        <div className="flex justify-between items-center gap-3 py-1">
          <div>Rotation</div>
          <div className="flex w-full items-center gap-3">
            <RangeSlider
              min={-180}
              max={180}
              defaultValue={selectedObject ? selectedObject.angle : 0}
              onChange={(angle: number) => handleUpdateProp("angle", angle)}
            />
          </div>
        </div>
      </div>

      <div className="py-2">
        {selectedEffect?.printMethodDetails?.makeOneColor ? (
          <div className="flex justify-between items-center border-b border-solid border-lightgrey py-2 relative">
            <div className="font-bold">
              Make One Color{" "}
              <span className="font-normal text-xs">Budget Friendly</span>
            </div>
            <div className="flex justify-between relative">
              {" "}
              <Checkbox
                name="onecolor"
                onChange={(flag: boolean) => {
                  setEnableColorPicker(flag);
                  if (!flag) updateFilter("removeFilter", "#000000");
                }}
              />
              {enableColorPicker && (
                <div className="flex justify-center w-[40%] ml-3 relative">
                  <button
                    onClick={() => setShowColorPicker((prev) => !prev)}
                    className={`text-xs text-center`}
                  >
                    <svg
                      className="mx-auto"
                      width="25"
                      height="25"
                      viewBox="0 0 43 43"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                    >
                      <rect width="43" height="43" fill="url(#pattern0)" />
                      <defs>
                        <pattern
                          id="pattern0"
                          patternContentUnits="objectBoundingBox"
                          width="1"
                          height="1"
                        >
                          <use
                            xlinkHref="#image0_43878_33141"
                            transform="scale(0.02)"
                          />
                        </pattern>
                        <image
                          id="image0_43878_33141"
                          width="50"
                          height="50"
                          xlinkHref="data:image/png;base64,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"
                        />
                      </defs>
                    </svg>
                  </button>
                </div>
              )}{" "}
              <ColorPicker
                title="Choose Color"
                colors={availableColors}
                show={showColorPicker}
                setShowColorPicker={setShowColorPicker}
                setNewColor={(color: string) => {
                  updateFilter("filters", color);
                }}
                // setNewColor={setNewColor}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        {/* {selectedEffect?.printMethodDetails?.removeBackground ? (
          <div className="flex justify-between items-center border-b border-solid border-lightgrey py-2 relative">
            <div className="font-bold">Remove Background</div>
            <div className="flex justify-between relative">
              <Checkbox
                disabled={backgroundLoading}
                name="onecolor"
                onChange={(flag: boolean) => {
                  removeBackground(flag);
                }}
              />{" "}
              {backgroundLoading ? (
                <MoonLoader color="#e44d4d" size={20} />
              ) : null}
            </div>
          </div>
        ) : (
          ""
        )} */}

        {/* Threshold Adjustment Slider - Only show when an image is selected and has background removal applied */}
        {selectedObject &&
        (selectedObject.is_remove_background ||
          selectedEffect?.printMethodDetails?.removeBackground) ? (
          <div className="flex justify-between items-center border-b border-solid border-lightgrey py-2">
            <div className="font-bold">
              Color Sensitivity
              <div className="font-normal text-xs">
                Adjust how aggressively colors are removed
              </div>
            </div>
            <div className="flex w-full max-w-[200px] items-center gap-3">
              <RangeSlider
                min={0}
                max={100}
                defaultValue={threshold}
                value={threshold}
                onChange={(value: number) => {
                  setThreshold(value);

                  // Debounce the processing to avoid excessive processing
                  if (debounceTimerRef.current) {
                    clearTimeout(debounceTimerRef.current);
                  }

                  debounceTimerRef.current = setTimeout(() => {
                    // Use the same pattern as invert_color does - directly set a property
                    // that will be processed by the renderer
                    console.log('Updating background threshold:', value);
                    
                    if (selectedObject) {
                      // First mark the object as having background removal if not already
                      if (!selectedObject.is_remove_background) {
                        handleUpdateProp("is_remove_background", true);
                      }
                      
                      // Then update the threshold property
                      handleUpdateProp("background_threshold", value);
                      
                      // Make sure any overlays or patterns are preserved by not replacing the image
                      canvas.renderAll();
                    }
                  }, 100); // Short debounce for better real-time feedback
                }}
              />
              <span className="text-xs">{threshold}%</span>
            </div>
          </div>
        ) : null}

        {selectedEffect?.printMethodDetails?.invertDesign ? (
          <div className="flex justify-between items-center border-b border-solid border-lightgrey py-2 relative">
            <div className="font-bold">Invert Design</div>
            <div className="flex justify-between relative">
              <Checkbox
                defaultValue={!selectedObject?.invert_color}
                name="invertDesign"
                onChange={(flag: boolean) => {
                  handleUpdateProp("invert_color", flag);
                }}
              />
            </div>
          </div>
        ) : (
          ""
        )}

        <div className="flex justify-between items-center border-b border-solid border-lightgrey py-2">
          <div className="font-bold"> Colors</div>
          <div
            onClick={() => {
              //handleChangeColors;
            }}
            className="flex justify-end gap-1 cursor-pointer"
          >
            {getUniqueArray(colorPalette).map((color, index) => (
              <div
                key={index}
                className="w-[24px] h-[24px] rounded-full border border-solid border-[#CCCFD6]"
                style={{ backgroundColor: color }}
              ></div>
            ))}
          </div>
        </div>
        {/* <div className="flex justify-between items-center border-b border-solid border-lightgrey py-2 hidden">
          <div className="font-bold">Remove Background</div>
          <Checkbox
            name="removebg"
            onChange={(val: any, a: any) => {
              console.log(a);
              removeBackgroundColor(val);
            }}
          />
        </div> */}
        <div className="flex justify-between items-center py-2">
          <div className="font-bold">
            Art Size <div className="font-normal text-xs">Width X Height</div>
          </div>
          <div className="text-sm">
            <input
              type="text"
              onChange={updateWidth}
              defaultValue="0.0"
              value={selectedWidth}
              className="w-[55px] py-1 text-center border border-solid border-lightgrey outline-none"
            />{" "}
            in X{" "}
            <input
              type="text"
              onChange={updateHeight}
              defaultValue="0.00"
              value={selectedHeight}
              className="w-[55px] py-1 text-center border border-solid border-lightgrey outline-none"
            />{" "}
            in
          </div>
        </div>
        <div className="text-right">
          <button
            onClick={handleReset}
            className="px-7 py-2 bg-white text-primaryred"
          >
            Reset to original
          </button>
          {/* <button
            onClick={() => setShowSaveDesign(true)}
            className="px-7 py-2 my-2 bg-primaryred rounded-md font-bold text-white"
          >
            Save Design
          </button> */}
        </div>
        <div className="text-right">
          <button
            onClick={deSelectObjectAction}
            className="py-2 bg-white text-primaryred"
          >
            {"< Upload Additional Image"}
          </button>
        </div>
      </div>
      <Infoblock type="warning">
        <div className="flex justify-center items-center gap-5">
          <svg
            width="30"
            height="50"
            viewBox="0 0 30 50"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M29.5833 14.0292C29.5833 22.7042 21.7708 28.5708 21.7708 35.4167H17.6208C17.6229 31.0854 19.6979 27.4458 21.7208 23.9312C23.6208 20.6292 25.4167 17.5083 25.4167 14.0292C25.4167 7.55417 20.1729 4.16667 14.9917 4.16667C9.81874 4.16667 4.58332 7.55417 4.58332 14.0292C4.58332 17.5083 6.37916 20.6292 8.27916 23.9312C10.3021 27.4458 12.375 31.0854 12.3771 35.4167H8.22916C8.22916 28.5708 0.416656 22.7021 0.416656 14.0292C0.416656 4.98125 7.70416 0 14.9917 0C22.2875 0 29.5833 4.9875 29.5833 14.0292ZM21.25 38.5417C21.25 39.1167 20.7833 39.5833 20.2083 39.5833H9.79166C9.21666 39.5833 8.74999 39.1167 8.74999 38.5417C8.74999 37.9667 9.21666 37.5 9.79166 37.5H20.2083C20.7833 37.5 21.25 37.9667 21.25 38.5417ZM21.25 42.7083C21.25 43.2833 20.7833 43.75 20.2083 43.75H9.79166C9.21666 43.75 8.74999 43.2833 8.74999 42.7083C8.74999 42.1333 9.21666 41.6667 9.79166 41.6667H20.2083C20.7833 41.6667 21.25 42.1333 21.25 42.7083ZM17.7062 49.2896C17.3104 49.7396 16.7375 50 16.1375 50H13.8604C13.2604 50 12.6896 49.7396 12.2937 49.2896L9.27082 45.8333H20.7292L17.7062 49.2896Z"
              fill="black"
            />
          </svg>

          <div>
            <div className="font-bold">Design not as expected on product?</div>
            <div className="text-sm">
              Our designers will redraw your logo from scratch when order to
              ensure the perfect result with every order!
            </div>
          </div>
        </div>
      </Infoblock>

      <Popup
        show={showSaveDesign}
        setShow={setShowSaveDesign}
        title="Save Design"
      >
        <SaveDesign isLoggedIn={isLoggedIn} />
      </Popup>
      <Popup show={show} setShow={setShow} title="Error!">
        <div className="upload-error p-5 text-center">
          <div className="justify-content-center">
            <h4 className="upload-error-title">
              <span>
                <span>Oops!</span>{" "}
                <span>
                  Your file is an unsupported file type or error in uploading.
                </span>
              </span>
            </h4>
            <p>
              Accepted file types (max size: 5 MB): .JPG .JPEG .PNG .GIF .BMP
              .PDF .AI .PSD .EPS
            </p>
            <p>
              Have a different type of file? <a href="#/help">Email it to us</a>{" "}
              and we'll have it ready for you to use within a few hours!{" "}
            </p>
          </div>
          <div className="modal-footer d-flex justify-content-center">
            <button
              onClick={() => {
                setShow(false);
              }}
              type="button"
              className="border-2 border-blue-500 bg-white text-black font-semibold py-2 px-4 min-w-[200px] rounded"
              data-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </Popup>
    </>
  );
};
export default EditUpload;
